import { ParamterType } from './paramter-type.enum';

export class SupplementaryEquipment {
    key: string;
    dictionaryKey: string;
    selected: boolean;
    parameter1DictionaryKey: string;
    parameter1Type: ParamterType;
    parameter1Value: string;

    constructor(se: SupplementaryEquipment) {
        this.key = se.key;
        this.dictionaryKey = se.dictionaryKey;
        this.selected = se.selected;
        this.parameter1DictionaryKey = se.parameter1DictionaryKey;
        this.parameter1Type = se.parameter1Type;
        this.parameter1Value = se.parameter1Value;
    }
}

